export const bomListQueryKey = ["boms", "list"];
export const bomDetailQueryKey = (bomId) => ["boms", "detail", bomId];

export const customerQueryKey = ["customer", "me"];
export const customerSubscriptionQueryKey = ["customer", "subscription"];
export const customerDataExportQueryKey = ["customer", "dataExport"];
export const customerCompanyLogoQueryKey = ["customer", "companyLogo"];

export const certificateListQueryKey = ["certificates", "list"];
export const certificateDetailQueryKey = (certificateId) => ["certificates", "detail", certificateId];
export const certificateAllowanceQueryKey = ["certificates", "allowance"];

export const qualificationPdfQueryKey = (bomId) => ["qualificationPdf", bomId];

export const paymentPricesQueryKey = ["payments", "prices"];
export const paddleTransactionListQueryKey = ["payments", "transactions"];

export const creditsAvailableQueryKey = ["usage", "creditsAvailable"];
export const bomCountAvailableQueryKey = ["usage", "bomCountAvailable"];
export const totalBomsPurchasedQueryKey = ["usage", "totalBomsPurchased"];
